<template>
  <div class="slideBox all-session-starts" :class="this.$route.query.source">

    <div class="slideHeader">
      <h1>
        <span class="source">{{ this.$route.query.sourceTitle }}</span>
        Session Starts
      </h1>
      <h2>Letzte 7 Tage</h2>
    </div>


      <div class="totalValuesWrapper">

        <div class="total-value all-session-starts-total">
          <div class="headlineBlock">
            <div class="svg average"></div>
            <h2>Hördauer</h2>
          </div>
          <div class="big value">
            <i-count-up
              :start="0"
              :end="totalValueEnd"
              :decimals="1"
              :duration="countDuration"
              :options="options1"
            ></i-count-up>
            <span class="unit">min</span>
          </div>
        </div>

        <div class="total-value all-session-starts-total">
          <div class="headlineBlock">
          <div class="svg bounce"></div>
          <h2>Qualtitative Bouncerate</h2>
          </div>
          <div class="big value">
            <i-count-up
              :start="0"
              :end="totalValueQualEnd"
              :decimals="1"
              :duration="countDuration"
              :options="options2"
            ></i-count-up>
          </div>
        </div>
      </div>

      <div class="chartWrapper">
        <div class="headlineBlock">
          <div class="svg hear"></div>
          <h2>Verteilung Sessions nach Hördauer</h2>
        </div>
        <pie-chart class="pieChart" v-if="dataSessionLength" :data="dataSessionLength" :height="80"></pie-chart>
      </div>

  </div>
</template>

<script>
import ICountUp from 'vue-countup-v2'
import _ from 'lodash'
import PieChart from '@/components/charts/pie-chart'

export default {
  name: 'all-session-starts',
  components: {
    ICountUp,
    PieChart
  },
  data () {
    return {
      countDuration: this.$store.state.countDuration,
      totalValueEnd: 0,
      totalValueQualEnd: 0,
      dataSessionLength: null,
      pieChartColors: [
        '#9f6427',
        '#4b9f2a',
        '#3aa18a',
        '#969120',
        '#982126'
      ],
      options1: {
        useEasing: true,
        useGrouping: true,
        separator: '.',
        decimal: ','
      },
      options2: {
        useEasing: true,
        useGrouping: true,
        separator: '.',
        decimal: ',',
        suffix: '%'
      }
    }
  },
  mounted () {
    const self = this
    const theme = this.$route.query.theme
    const source = this.$route.query.source
    const urlPart = theme + '-' + source + '_all_session_starts'
    const urlPart2 = theme + '-stream_qual_bouncerate_all_session_starts'
    const urlPart3 = theme + '-stream_duration_cluster_all_session_starts'
    const currentSlide = this.$store.state.allSlides[this.$route.query.id]

    /* chart colors */
    if (currentSlide.pieChartColors) {
      this.pieChartColors = currentSlide.pieChartColors
    }

    /* average duration */
    const totalValueURL = urlPart + '-last_7_days'
    this.axios.get(totalValueURL).then((response) => {
      self.totalValueEnd = parseFloat(_.head(response.data.results).avgDuration)
    })

    /* qual. bouncerate */
    const totalValueQualURL = urlPart2 + '-last_7_days'
    self.axios.get(totalValueQualURL).then((response) => {
      self.totalValueQualEnd = parseFloat(_.head(response.data.results).percent)
    })

    /* chart data */
    const chartDataURL = urlPart3 + '-last_7_days'
    self.axios.get(chartDataURL).then((response) => {
      self.fillData(response.data.results)
    })
  },
  methods: {
    fillData (data) {
      const groups = []
      const percents = []

      /* fill arrays */
      _.each(data, (entry) => {
        groups.push(entry['ICECAST.listenerTimeSegment'])
        percents.push(parseFloat(entry['sum(count)']))
      })

      /* paid likes */
      this.dataSessionLength = {
        labels: groups,
        datasets: [
          {
            segmentStrokeWidth: 20,
            segmentStrokeColor: 'rgba(255, 255, 255, 0.4)',
            backgroundColor: this.pieChartColors,
            borderWidth: 0,
            data: percents
          }
        ]
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/all-session-starts.vue